module.exports = __webpack_public_path__ + "static/media/kokkaany4.bee09f1a.avif";